import { Bias } from "./Bias";

import animations from './animations';

export class Biases {
  constructor(callback) {
    this.biases = [];
    window.biasJson.forEach((data) => {
      this.biases.push(new Bias(data, animations[data.slug]));
    });
    callback(this);
  }

  count() {
    return this.biases.length;
  }

  forEach(callback) {
    return this.biases.forEach(callback);
  }

  lastIndexOf() {
    return this.biases.length - 1;
  }

  indexOf(bias) {
    return this.biases.indexOf(bias);
  }

  first() {
    return this.biases[0];
  }

  prev(bias) {
    let index = this.indexOf(bias);

    if (index === 0) {
      return this.biases[this.lastIndexOf()];
    }

    return this.biases[index - 1];
  }

  next(bias) {
    let index = this.indexOf(bias);

    if (index === this.lastIndexOf()) {
      return this.biases[0];
    }

    return this.biases[index + 1];
  }

  get(index) {
    if (typeof index === 'number') {
      return this.biases[index];
    }

    if (typeof index === 'string') {
      return this.biases.filter((bias) => bias.slug === index)[0];
    }

    return undefined;
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/src/biases/Biases.js